import { Check } from "lucide-react";

export function ModuleCard({ mod, isSelected, onToggle, t, language }) {
    const label = language === "es" ? mod.labelEs : mod.label;
    const description = language === "es" ? mod.descriptionEs : mod.description;

    return (
        <button
            onClick={() => onToggle(mod.key)}
            className={`
                relative text-left rounded-xl border-2 p-4 transition-all duration-150
                ${isSelected
                    ? "border-blue-500 bg-blue-50/50 shadow-sm"
                    : "border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm"
                }
            `}
        >
            {isSelected && (
                <div className="absolute top-2 right-2 w-5 h-5 rounded-full bg-blue-500 flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                </div>
            )}
            <h4 className="text-sm font-semibold text-gray-900 pr-6">{label}</h4>
            <p className="text-xs text-gray-500 mt-1 line-clamp-2">{description}</p>
            <div className="flex items-center gap-2 mt-2">
                <span className="text-xs font-medium text-blue-600 bg-blue-50 px-2 py-0.5 rounded-full">
                    ~{mod.avgFiles} {t("billing.moduleCosts.files") || "files"}
                </span>
                <span className="text-xs text-gray-400">
                    ~{mod.creditsPerModule} {t("billing.moduleCosts.credits") || "credits"}
                </span>
            </div>
        </button>
    );
}
